<template>
    <Panel class="w-full" data-testid="friend-item" :data-friend-name="friend.tag_name">
        <div class="flex items-center justify-between" :class="{'max-md:flex-col max-md:gap-3 max-md:items-start': buttonsNewLine}">
            <div class="flex items-center space-x-3" :class="{ 'w-full': !showButton }">
                <div class="relative">
                    <img v-avatar-fallback="friend.avatar" alt="" class="border-stroke-1 h-10 w-10 border" />
                    <div
                        v-if="isOnline && showOnlineIndicator"
                        class="absolute -right-1 -bottom-1 h-3 w-3 rounded-full border-2 border-zinc-900 bg-green-500"
                    ></div>
                </div>
                <div class="flex-1">
                    <p class="text-sm font-semibold text-white">
                        {{ friend.tag_name }}
                    </p>
                    <p class="text-titles text-sm">
                        {{ friend.name }}
                    </p>
                </div>
            </div>
            <div v-if="showButton" :class="buttonsNewLine ? 'max-md:mt-3 max-md:w-full' : ''">
                <slot name="button" :friend="friend">
                    <DiagonalCutButton
                        variant="primary"
                        cut-position="left-top"
                        :full-width="false"
                        :loading="isLoading"
                        :disabled="isLoading"
                        data-testid="friend-item-action-button"
                        @click="$emit('action', friend)"
                    >
                        {{ buttonText || $t('general.add_plus') }}
                    </DiagonalCutButton>
                </slot>
            </div>
        </div>
    </Panel>
</template>

<script>
import Panel from '@/components/layout/Panel.vue'
import DiagonalCutButton from '@/components/ui/DiagonalCutButton.vue'

export default {
    name: 'FriendItem',
    components: { Panel, DiagonalCutButton },
    props: {
        friend: {
            type: Object,
            required: true,
        },
        showButton: {
            type: Boolean,
            default: true,
        },
        buttonText: {
            type: String,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        showOnlineIndicator: {
            type: Boolean,
            default: false,
        },
        isOnline: {
            type: Boolean,
            default: false,
        },
        loadingFriendId: {
            type: [String, Number],
            default: null,
        },
        buttonsNewLine: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['action'],
    computed: {
        isLoading() {
            return this.loadingFriendId === this.friend.id
        },
    },
}
</script>
